import { atmBackConfiguration } from "@/setup/restAtmBackClient";
import { UsersApi } from "@socotec.io/atm-back-sdk";

const api = new UsersApi(atmBackConfiguration);

/**
 * The authenticated user, fully resolved (agency / socotec_code / telephone).
 * @returns {Promise<object>}
 */
export const resolveUser = async () => {
  return await api.me();
};

/**
 * Patch a user (keyed by its usermanagement_uuid). Read-only fields in the
 * payload are dropped by the SDK.
 * @param {string} usermanagementUuid
 * @param {object} userData fields to update
 * @returns {Promise<object>}
 */
export const updateUser = async (usermanagementUuid, userData) => {
  return await api.partialUpdate({
    usermanagementUuid,
    patchedUserRequest: userData,
  });
};
